import React from 'react';
import PropTypes from 'prop-types';

import MerchCard from 'components/Cards/MerchCard';

const MerchGrid = ({ data }) => {

    return (
        <div className='tickets-grid'>
            {data.map((item, index) => {
                return <MerchCard item={ item } key={ index } />
            })}
        </div>
    );
};

MerchGrid.propTypes = {
    data: PropTypes.array,
};

export default MerchGrid;
